'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ArrowLeft, Download } from 'lucide-react';
import Link from 'next/link';

export default function BRDocPage() {
  const pdfUrl = '/assets/BRdoc.pdf';

  return (
    <div className="min-h-screen bg-[#F6FBFF] font-mono selection:bg-[#548DC8] selection:text-white pt-32 pb-20">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-10 flex flex-col md:flex-row md:items-end justify-between gap-6"
        >
          <div>
            <Link 
              href="/"
              className="inline-flex items-center gap-2 text-[#548DC8] hover:gap-3 transition-all text-xs font-bold uppercase tracking-widest mb-6"
            >
              <ArrowLeft className="w-4 h-4" /> Back to Home
            </Link>
            <h1 className="text-4xl md:text-5xl font-display uppercase leading-tight text-[#1a5b9b]">
              Business <span className="text-[#548DC8]">Registration</span>
            </h1>
            <p className="text-slate-500 mt-2 text-sm uppercase tracking-widest font-medium">
              Official registration document for Baasil Topup
            </p>
          </div>
          
          <a 
            href={pdfUrl}
            download="Baasil_Topup_BR.pdf"
            className="inline-flex items-center gap-2 bg-[#548DC8] text-white px-6 py-3 rounded-xl font-bold uppercase tracking-wider text-xs hover:bg-[#4377B0] transition-all shadow-lg hover:scale-105 active:scale-95"
          >
            <Download className="w-4 h-4" /> Download PDF
          </a>
        </motion.div>

        {/* PDF Viewer Container */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="w-full h-[80vh] bg-white rounded-3xl shadow-2xl overflow-hidden border-[6px] border-white drop-shadow-xl relative flex flex-col"
        >
          {/* Viewer Toolbar */}
          <div className="h-14 bg-slate-50 border-b border-slate-100 flex items-center px-6 justify-between shrink-0">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-rose-100 flex items-center justify-center text-rose-500">
                <FileText className="w-4 h-4" />
              </div>
              <span className="text-xs font-bold text-slate-600 uppercase tracking-widest">Business Registration Image</span>
            </div>
          </div>

          {/* Actual Image Viewer */}
          <div className="flex-1 bg-slate-100 relative overflow-auto flex justify-center items-start p-4 md:p-10">
            <img 
              src="/assets/br.png"
              className="max-w-full shadow-2xl rounded-lg border border-slate-200"
              alt="Business Registration Document"
            />
          </div>
        </motion.div>

        {/* Footer Note */}
        <p className="mt-8 text-center text-[10px] text-slate-400 uppercase tracking-[0.2em] font-medium max-w-2xl mx-auto">
          Baasil Topup is a registered business entity. This document is provided for transparency and verification purposes only.
        </p>
      </div>
    </div>
  );
}
